import { BillingRecurringTypes } from "app/models/ss-api/price.billing.cycle";

export interface IUpgradeProductRequest {

    LicenseKey: string;
    NewProductID: number;
    CreditCardID: number;
    NewBillingCycle: BillingRecurringTypes;
    Initials: string;
    SimulateOnly: boolean;
    PromoCode: string;
    AdminID: number;

}

export class UpgradeProductRequest implements IUpgradeProductRequest {

    LicenseKey: string;
    NewProductID: number;
    CreditCardID: number;
    NewBillingCycle: BillingRecurringTypes;
    Initials: string;
    SimulateOnly: boolean;
    PromoCode: string;
    AdminID: number;

}
